import React from 'react';

const LoadingSplash = () => {
    // Stili inline per rendere il componente autonomo
    const containerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh', width: '100vw', backgroundColor: '#FFFFFF' };
    const spinnerStyle = { border: '5px solid #f3f3f3', borderTop: '5px solid #3498db', borderRadius: '50%', width: '50px', height: '50px', animation: 'spin 1.5s linear infinite' };
    const textStyle = { marginTop: '20px', fontSize: '1.2rem', color: '#6c77d', fontWeight: '500' };
    const keyframes = `@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;

    return (
        <div style={containerStyle}>
            <style>{keyframes}</style>
            <div style={spinnerStyle}></div>
            <p style={textStyle}>Caricamento in corso...</p>
        </div>
    );
};

export default LoadingSplash;
